// extracted by mini-css-extract-plugin
export default {"block__direction":"l3GyBm","darkFont":"sBN77V mz-default-dark-font","title":"WBmfYM","route":"o5rQYZ","mobile":"urauuj"};